import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { ConfigProvider } from 'antd';
import faIR from 'antd/lib/locale/fa_IR';
import ThemeProvider from './theme/ThemeProvider';
import Auth from './pages/Auth';
import Home from './pages/Home';
import TripDetails from './pages/TripDetails';
import TripOptions from './pages/TripOptions';
import Trip from './pages/Trip';
import Profile from './pages/Profile';
import Layout from './components/Layout';
import OTPVerification from './pages/OTPVerification';
import UserRegistration from './pages/UserRegistration';
import ProtectedRoute from './components/ProtectedRoute';
import TripsHistory from './pages/TripsHistory';
import About from './pages/About';
import './theme/global.css';
import './index.css';

const AppWrapper = styled.div`
  direction: rtl;
  text-align: right;
  min-height: 100vh;
  background: var(--color-background);
`;

const App: React.FC = () => {
  return (
    <ThemeProvider defaultTheme="light">
      <ConfigProvider direction="rtl" locale={faIR} theme={{
        token: {
          colorPrimary: 'var(--color-primary)',
          colorSuccess: 'var(--color-success)',
          colorWarning: 'var(--color-warning)',
          colorError: 'var(--color-error)',
          colorInfo: 'var(--color-info)',
          borderRadius: 8,
          colorBgContainer: 'var(--color-surface)',
          colorText: 'var(--color-text-primary)',
          colorTextSecondary: 'var(--color-text-secondary)',
          colorBorder: 'var(--color-border)',
          fontFamily: 'Vazir, sans-serif',
        },
      }}>
        <AppWrapper>
          <Router>
            <Routes>
              <Route path="/" element={<Auth />} />
              <Route path="/verify-otp" element={<OTPVerification />} />
              <Route path="/user-registration" element={<UserRegistration />} />
              <Route 
                path="/home" 
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Home />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/home/trip-details" 
                element={
                  <ProtectedRoute>
                    <Layout>
                      <TripDetails />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/home/trip-options" 
                element={
                  <ProtectedRoute>
                    <Layout>
                      <TripOptions />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Profile />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/trip/:tripId" 
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Trip />
                    </Layout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/trip" 
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Trip />
                    </Layout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/tripsHistory" 
                element={
                  <ProtectedRoute>
                    <Layout>
                      <TripsHistory />
                    </Layout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/about" 
                element={
                  <ProtectedRoute>
                    <Layout>
                      <About />
                    </Layout>
                  </ProtectedRoute>
                } 
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </AppWrapper>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default App;

